import { TAG_COLORS, TAG_COLOR_KEYS } from "./constants";

/**
 * Resolve a Tailwind color name to bg + text classes for an avatar fallback.
 * Uses the saved value when present, otherwise hashes the user id so each
 * person stays the same color across sessions until they pick one explicitly.
 */
export function resolveAvatarColor(
  color: string | null | undefined,
  fallbackKey?: string | null,
): { bg: string; text: string } {
  const key = (color && TAG_COLORS[color] ? color : null) ?? hashColor(fallbackKey);
  const tag = TAG_COLORS[key] ?? TAG_COLORS.gray;
  return { bg: tag.dot, text: "text-white" };
}

/** Light variant for muted-bg avatars (used in members lists, etc.). */
export function resolveAvatarColorSoft(
  color: string | null | undefined,
  fallbackKey?: string | null,
): { bg: string; text: string } {
  const key = (color && TAG_COLORS[color] ? color : null) ?? hashColor(fallbackKey);
  const tag = TAG_COLORS[key] ?? TAG_COLORS.gray;
  return { bg: tag.pillBg, text: tag.pillText };
}

function hashColor(seed: string | null | undefined): string {
  if (!seed) return "gray";
  let h = 0;
  for (let i = 0; i < seed.length; i += 1) {
    h = (h * 31 + seed.charCodeAt(i)) | 0;
  }
  const idx = Math.abs(h) % TAG_COLOR_KEYS.length;
  return TAG_COLOR_KEYS[idx];
}
